import React from 'react';
import { Card } from '../components/ui/card';

const Values = () => {
  const values = [
    {
      title: 'Discipline',
      description: 'Content coming soon...'
    },
    {
      title: 'Growth',
      description: 'Content coming soon...'
    },
    {
      title: 'Freedom',
      description: 'Content coming soon...'
    }
  ];

  return (
    <div className="bg-gradient-to-b from-[#e8f4fd] to-[#f0f8ff] min-h-screen py-20">
      <div className="max-w-5xl mx-auto px-6">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 text-center">
          Values & Culture
        </h1>
        <p className="text-xl text-gray-600 text-center mb-12">
          The principles that guide everything we do
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((value, index) => (
            <Card key={index} className="bg-white rounded-3xl p-8 text-center hover:shadow-lg transition-all">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-orange-100 to-orange-50 flex items-center justify-center mx-auto mb-6">
                <span className="text-4xl font-bold text-orange-500">{index + 1}</span>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h2>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Values;